
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    next: Function,
    prev: Function,
  },
  methods: {
    leftEnter(){
      this.$emit('leftEnter');
    },
    leftLeave(){
      this.$emit('leftLeave');
    },
    rightEnter(){
      this.$emit('rightEnter');
    },
    rightLeave(){
      this.$emit('rightLeave');
    },
  }
});
